const type = 'CLOSE_CARD_UNBLOCK';

const closeCardUnblock = () => ({
  type,
});

export { type };
export default closeCardUnblock;
